import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import ButtonDefault from '@/components/ui/ButtonDefault';
import { useEvaluationCategories } from './hooks/useEvaluationCategories';
import { CardContent } from '@/components/views/Resolution886/CardContent';
import { EvaluationCategoriesForm } from './Form/EvaluationCategoriesForm';

interface EvaluationCategoriesStepProps {
	goToSubStep: (step: number) => void;
}

export function EvaluationCategoriesStep({ goToSubStep }: Readonly<EvaluationCategoriesStepProps>): JSX.Element {
	const { isLoading } = useEvaluationCategories({
		goToSubStep
	});

	function handleOnNextStep(): void {
		goToSubStep(1);
	}

	function handleOnPreviousStep(): void {
		goToSubStep(1);
	}

	return (
		<Row justify="center" align="middle" gutter={[16, 16]}>
			<Col span={24}>
				<CardContent>
					<EvaluationCategoriesForm goToSubStep={goToSubStep} />
				</CardContent>
			</Col>
			<Col>
				<Row gutter={[16, 16]}>
					<Col>
						<ButtonDefault type="default" loading={isLoading} onClick={handleOnPreviousStep}>
							{I18n.get('Back')}
						</ButtonDefault>
					</Col>
					<Col>
						<ButtonDefault type="primary" loading={isLoading} onClick={handleOnNextStep}>
							{I18n.get('Next')}
						</ButtonDefault>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
